import Modal from "../../widgets/Modal";
import { handleAuth, listenAuthState } from "../../api/gapi";
import { useEffect } from "react";

const GoogleAuthModal = ({ setModalOn }) => {
  useEffect(() => {
    listenAuthState((signedIn) => {
      console.log(signedIn);
      setModalOn(!signedIn);
    });
  }, []);

  return (
    <Modal
      leftText={"Authorize"}
      leftFunc={handleAuth}
      rightText={"Cancel"}
      rightFunc={() => {
        setModalOn(false);
      }}
    >
      The file cannot be processed by WebOS. Would you like to authorize WebOS
      to connect with your Google Drive and upload files of this type?
    </Modal>
  );
};
export default GoogleAuthModal;
